// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4376":"31420fc2","7208":"37ac1a96","8898":"31420fc2"}[chunkId] + ".chunk.css";
};